import React, { useEffect, useState } from "react";
import { Card, Col, Row, Select, Table, Tag } from "antd";
import { useBts } from "./BtsStore";
import { firstDefined, statusColor, toOptions } from "./helpers";

const autoColumns = (rows) => {
    const sample = rows?.[0];
    if (!sample || typeof sample !== "object") return [{ title: "Qiymat", render: (_, r) => String(r) }];
    return Object.keys(sample).slice(0, 6).map((k) => ({
        title: k,
        dataIndex: k,
        key: k,
        render: (v) => (typeof v === "object" ? JSON.stringify(v) : String(v ?? "—")),
    }));
};

const BtsCatalog = () => {
    const {
        regions, getRegions, cities, getCities, branches, getBranches,
        packages, getPackages, postTypes, getPostTypes, statuses, getStatuses,
    } = useBts();

    const [region, setRegion] = useState(null);
    const [city, setCity] = useState(null);

    useEffect(() => {
        getRegions();
        getPackages();
        getPostTypes();
        getStatuses();
    }, [getRegions, getPackages, getPostTypes, getStatuses]);

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
                <Card size="small" title="Viloyatlar va shaharlar">
                    <Select
                        style={{ width: "100%", marginBottom: 12 }}
                        showSearch optionFilterProp="label" placeholder="Viloyatni tanlang"
                        value={region}
                        options={toOptions(regions, ["code", "region_code", "id"], ["name", "nameuz", "title"])}
                        onChange={(v) => { setRegion(v); setCity(null); getCities(v); }}
                    />
                    <Table
                        rowKey={(r) => firstDefined(r, ["code", "city_code", "id"]) ?? Math.random()}
                        size="small"
                        columns={autoColumns(cities)}
                        dataSource={cities}
                        pagination={{ pageSize: 8 }}
                        locale={{ emptyText: "Viloyatni tanlang" }}
                    />
                </Card>
            </Col>

            <Col xs={24} lg={12}>
                <Card size="small" title="Filiallar">
                    <Select
                        style={{ width: "100%", marginBottom: 12 }}
                        showSearch optionFilterProp="label" placeholder="Shaharni tanlang"
                        value={city}
                        options={toOptions(cities, ["code", "city_code", "id"], ["name", "nameuz", "title"])}
                        onChange={(v) => { setCity(v); getBranches(v); }}
                    />
                    <Table
                        rowKey={(r) => firstDefined(r, ["code", "branch_code", "id"]) ?? Math.random()}
                        size="small"
                        columns={autoColumns(branches)}
                        dataSource={branches}
                        pagination={{ pageSize: 8 }}
                        locale={{ emptyText: "Shaharni tanlang" }}
                    />
                </Card>
            </Col>

            <Col xs={24} lg={8}>
                <Card size="small" title="Qadoq turlari (packages)">
                    <Table rowKey={(r) => firstDefined(r, ["id", "code"]) ?? Math.random()} size="small"
                        columns={autoColumns(packages)} dataSource={packages} pagination={false} scroll={{ y: 280 }} />
                </Card>
            </Col>

            <Col xs={24} lg={8}>
                <Card size="small" title="Yuborish turlari (post types)">
                    <Table rowKey={(r) => firstDefined(r, ["id", "code"]) ?? Math.random()} size="small"
                        columns={autoColumns(postTypes)} dataSource={postTypes} pagination={false} scroll={{ y: 280 }} />
                </Card>
            </Col>

            <Col xs={24} lg={8}>
                <Card size="small" title="Statuslar">
                    <Table
                        rowKey={(r) => firstDefined(r, ["code", "id"]) ?? Math.random()}
                        size="small"
                        pagination={false}
                        scroll={{ y: 280 }}
                        dataSource={statuses}
                        columns={[
                            { title: "Kod", width: 80, render: (_, r) => <Tag color={statusColor(firstDefined(r, ["code", "id"]))}>{firstDefined(r, ["code", "id"]) ?? "—"}</Tag> },
                            { title: "Nomi", render: (_, r) => firstDefined(r, ["name", "nameuz", "title"]) ?? "—" },
                        ]}
                    />
                </Card>
            </Col>
        </Row>
    );
};

export default BtsCatalog;
